// ===============================================
// 📘 Configuração Global do Site - Click Sorvetes
// Local: src/config/siteInfo.js
// ===============================================

export const siteInfo = {
  empresa: "Click Sorvetes",

  // 📧 Contato principal
  email: "contato@clicksorvetes.com.br",
  telefone: "+55 (11) 91594-6319",
  whatsapp: "5511915946319",

  // 📍 Endereço institucional (opcional)
  endereco: "Rua das Sobremesas, 100 - São Paulo/SP",

  // 🌐 Redes sociais oficiais
  redes: {
    instagram: "https://instagram.com/clicksorvetes",
    facebook: "https://facebook.com/clicksorvetes",
    whatsapp: "https://wa.me/5511915946319", // formato internacional
  },

  // 📰 Configurações de newsletter / contato
  newsletter: {
    ativo: true,
    placeholder: "Digite seu e-mail para receber novidades",
    mensagemSucesso: "E-mail enviado com sucesso! 🎉",
    mensagemErro: "Ocorreu um erro, tente novamente mais tarde.",
  },

  // ⚙️ Informações institucionais adicionais (usadas no footer ou em metatags)
  institucional: {
    descricaoCurta: "Um modelo de negócios pensado para crescer com você.",
    direitos: "© " + new Date().getFullYear() + " Click Sorvetes — Todos os direitos reservados.",
  },

  // INFORMAÇÕES DO LICENCIAMENTO
  licenciamentoValor: "R$ 5.000,00",
};
